
import { getAccountsByIdIncludingGoals } from 'data/accounts/retrievers';
import { isLoanAccountFromId, isInvestmentAccountFromId } from 'data/accounts/utils';
import { CoaTypeEnum, BalanceAdjustmentTypeEnum } from 'data/chartOfAccounts/types';

// export const getCoaId = (coa, allowBlank = false) => coa ? `${coa.type}:${coa.id}` : (allowBlank && 'BLANK') || 'UNCATEGORIZED';
export function getCoaId(coa, allowBlank = false) {
  if (!coa) {
    return allowBlank ? 'BLANK' : CoaTypeEnum.UNCATEGORIZED;
  }
  switch (coa.type) {
    case CoaTypeEnum.ACCOUNT:
      return coa.id;
    case CoaTypeEnum.BALANCE_ADJUSTMENT:
      return `${CoaTypeEnum.BALANCE_ADJUSTMENT}_${coa.id}`;
    case CoaTypeEnum.CATEGORY:
      return coa.id;
    case CoaTypeEnum.NONE:
      return coa.type;
    case CoaTypeEnum.UNCATEGORIZED:
    default:
      return CoaTypeEnum.UNCATEGORIZED;
  }
}

export function getBalanceAdjustmentString(id) {
  switch (id) {
    case BalanceAdjustmentTypeEnum.BALANCE_ADJUSTMENT:
      return 'Balance Adjustment';
    case BalanceAdjustmentTypeEnum.OPENING_BALANCE:
      return 'Opening Balance';
    case BalanceAdjustmentTypeEnum.TRANSFER:
      return 'Transfer';
    case BalanceAdjustmentTypeEnum.CREDIT_CARD_PAYMENT:
      return 'Credit Card Payment';
    default:
      assert(false, 'unknown coa.id for coa.type=BALANCE_ADJUSTMENT');
      return `ErrId:=>${String(id)}<=`;
  }
}

export const coaIsBalanceAdjustmentType = (coa) => (coa && coa.type === CoaTypeEnum.BALANCE_ADJUSTMENT);

export function isL1TransferCoa(coa) {
  return (coa && (coa.type === CoaTypeEnum.BALANCE_ADJUSTMENT) && (coa.id === BalanceAdjustmentTypeEnum.TRANSFER));
}

export const unSyncedIdsList = ['21', '22'];
export const TRANSFER_NOT_FOUND_COA_ID = '24';
export const unsupportedTypes = ['INVESTMENT', 'LOAN'];

// -------------------------------------------------------
// coasAreEqual
//
export function coasAreEqual(coa1, coa2) {
  if (!coa1 && !coa2) return true;
  if (!coa1 || !coa2) return false;
  return (coa1.type === coa2.type) && (coa1.id === coa2.id);
}

// -------------------------------------------------------
// isTransferCoaNotFound
//
// we don't support transactions for Loan or Investment accounts
// so we treat them as NOT FOUND
//
export function isTransferCoaNotFound(coa, state) {
  const accountsById = getAccountsByIdIncludingGoals(state);

  if (coa && (coa.type === CoaTypeEnum.ACCOUNT) && !unSyncedIdsList.includes(String(coa.id))) {
    return accountsById && !accountsById.has(coa.id);
  }
  return false;
}

// -------------------------------------------------------
// isUnsyncedTransferCoa
//
export function isUnsyncedTransferCoa(coa, state) {

  if (coa && (coa.type === CoaTypeEnum.ACCOUNT)) {
    return unSyncedIdsList.includes(String(coa.id)) || isTransferCoaNotFound(coa, state);
  }
  return false;

}
// -------------------------------------------------------
// isLoanAcctTransferCoa
//
export function isLoanAcctTransferCoa(coa, state) {

  if (coa && (coa.type === CoaTypeEnum.ACCOUNT)) {
    return isLoanAccountFromId(coa.id, state);
  }
  return false;
}
// -------------------------------------------------------
// isInvestmentAcctTransferCoa
//
export function isInvestmentAcctTransferCoa(coa, state) {

  if (coa && (coa.type === CoaTypeEnum.ACCOUNT)) {
    return isInvestmentAccountFromId(coa.id, state);
  }
  return false;
}

// -------------------------------------------------------
// isSupportedTransferCoa
//
export function isSupportedTransferCoa(coa, state) {

  const accountsById = getAccountsByIdIncludingGoals(state);

  if (coa && (coa.type === CoaTypeEnum.ACCOUNT)) {
    return (!isUnsyncedTransferCoa(coa, state) &&
      (accountsById && accountsById.has(coa.id) && unsupportedTypes.indexOf(accountsById.get(coa.id).type) < 0));
  }
  return false;
}
